import React from 'react';
import { motion } from 'framer-motion';
const episodes = [{
  label: 'AD 1',
  title: 'WHAT IS AD & SIGNS/SYMPTOMS',
  bg: 'bg-purple-500',
  borderColor: 'border-purple-600',
  image: 'https://cdn.magicpatterns.com/uploads/nEa1DRvQAYucUq43JHRZzk/Screenshot_2026-04-15_at_19.07.28.png'
}, {
  label: 'AD 2',
  title: 'CAUSES & TRIGGERS',
  bg: 'bg-emerald-500',
  borderColor: 'border-emerald-600',
  image: 'https://cdn.magicpatterns.com/uploads/m5peqBmvi2XAvZ7dCAA5qN/Screenshot_2026-04-15_at_19.07.54.png'
}, {
  label: 'AD 3',
  title: 'PREPARING FOR YOUR APPOINTMENT',
  bg: 'bg-amber-500',
  borderColor: 'border-amber-600',
  image: 'https://cdn.magicpatterns.com/uploads/dmpgepxhc8KHwcM4zavwLW/Screenshot_2026-04-15_at_19.20.27.png'
}];
export function CheMenuScreen() {
  return <section className="min-h-screen w-full bg-white flex flex-col items-center justify-center px-6 py-20" data-id="element-69">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="w-full max-w-5xl" data-id="element-70">
        <h2 className="text-3xl md:text-4xl font-bold text-purple-700 text-center mb-10" data-id="element-71">
          Menu & Episode Branching
        </h2>

        {/* Menu header */}
        <div className="flex justify-center mb-6" data-id="element-72">
          <div className="border-[3px] border-purple-600 rounded-lg bg-slate-100 px-8 py-6 text-center max-w-md w-full" data-id="element-73">
            <h3 className="text-2xl font-black text-slate-900 mb-1" data-id="element-74">
              EXPLORE MORE ABOUT AD
            </h3>
            <p className="text-xs font-bold text-slate-700 uppercase tracking-wide" data-id="element-75">
              Choose your next topic:
            </p>
          </div>
        </div>

        {/* Connecting lines */}
        <div className="flex justify-center mb-2" data-id="element-76">
          <div className="w-px h-8 bg-purple-300" data-id="element-77" />
        </div>
        <div className="flex justify-center mb-2" data-id="element-78">
          <div className="relative w-full max-w-4xl h-6" data-id="element-79">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[75%] h-px bg-purple-300" data-id="element-80" />
            {[0, 1, 2].map(i => <div key={i} className="absolute top-0 w-px h-6 bg-purple-300" style={{
            left: `${16.5 + i * (67 / 2)}%`
          }} data-id="element-81" />)}
          </div>
        </div>

        {/* Episode cards row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-82">
          {episodes.map((ep, i) => <motion.div key={ep.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.3 + i * 0.1
        }} className="flex flex-col items-center relative" data-id="element-83">
              {ep.isOptional && <div className="absolute -top-3 right-2 z-10 bg-rose-600 text-white text-[10px] font-bold px-2 py-1 rounded-full shadow-md transform rotate-3" data-id="element-84">
                  OPTIONAL SNAK
                </div>}
              <div className={`border-[3px] ${ep.borderColor} rounded-lg overflow-hidden w-full hover:scale-105 transition-transform cursor-pointer ${ep.isOptional ? 'opacity-90' : ''}`} data-id="element-85">
                {ep.image ? <div className="relative" data-id="element-86">
                    <img src={ep.image} alt={ep.title} className="w-full h-auto" data-id="element-87" />
                    <div className={`${ep.bg} px-3 py-3 absolute bottom-0 left-0 right-0 bg-opacity-95`} data-id="element-88">
                      <p className="text-xs font-black text-white leading-tight" data-id="element-89">
                        {ep.title}
                      </p>
                    </div>
                  </div> : <div className="flex flex-col" data-id="element-90">
                    {/* Gray top placeholder */}
                    <div className="bg-slate-200 h-24 flex items-end justify-center" data-id="element-91">
                      <div className="w-12 h-16 bg-slate-300/40 rounded-t-full" data-id="element-92" />
                    </div>
                    {/* Colored bottom with title */}
                    <div className={`${ep.bg} px-3 py-4`} data-id="element-93">
                      <p className="text-xs font-black text-white leading-tight mb-2" data-id="element-94">
                        {ep.title}
                      </p>
                      <div className="inline-block border-2 border-white bg-white/20 px-2 py-1" data-id="element-95">
                        <span className="text-[10px] font-black text-white" data-id="element-96">
                          LEARN MORE
                        </span>
                      </div>
                    </div>
                  </div>}
              </div>
              <p className={`mt-2 text-sm font-medium ${ep.isOptional ? 'text-rose-600' : 'text-slate-600'}`} data-id="element-97">
                {ep.label}
              </p>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}